<template>
  <el-form
    class="form form__passowrd_reset"
    ref="form"
    :model="passwordSetForm"
    :rules="rules"
    @submit.native.prevent="sendPasswordSet()"
    v-loading="!!loading">

    <messages :messages="messages" :request="request" :customErrorHandler="handleErrors"></messages>

    <input-password-field
      id="password"
      :disabled="!isOnline"
      v-model="passwordSetForm.password">
    </input-password-field>

    <div class="card__footer">
      <div class="card__footer_button_wrap">
        <el-button
          type="primary"
          native-type="submit"
          :disabled="!canSubmitForm"
        >
          {{$t('passwordResetSaveLabel')}}
        </el-button>
      </div>
      <p class="card__footer_footnote">
        <router-link class="card__footer_link" :to="{ name: 'Home' }" exact>
          {{$t('applicationCancel')}}
        </router-link>
      </p>
    </div>

  </el-form>
</template>

<script>
  import InputPasswordField from './inputs/InputPasswordField.vue';
  import validations from './inputs/validations';
  import authentication from '@/authentication';
  import i18n from '@/configured/vue-i18n';
  import { mapActions, mapState } from 'vuex';
  import Messages from './Messages.vue';
  import offline from '@/offline';

  export default {
    name: 'PasswordSetForm',
    data() {
      return {
        messages: [],
        passwordSetForm: {
          password: '',
        },
        request: null,
        loading: false,
        rules: {
          password: validations.rules().password,
        },
      }
    },
    computed: {
      ...mapState(offline.store.namespace, [
        'isOnline'
      ]),
    },
    methods: {
      ...mapActions(authentication.store.namespace, [
        'setPassword',
      ]),
      handleSuccess() {
        this.messages = [];
        this.$emit('success');
      },
      handleErrors() {
        return i18n.i18n.t('passwordResetServerFailure');
      },
      sendPasswordSet() {
        this.messages = [];
        this.loading = true;
        this.request = this.setPassword(this.passwordSetForm.password).
          then(this.handleSuccess);
        this.request.then(()=>{ this.loading=false }, ()=>{ this.loading=false });
      },
      canSubmitForm() {
        return !!(
          this.isOnline && 
          this.passwordSetForm.password
        );
      }
    },
    components: {
      InputPasswordField,
      Messages
    }
  }
</script>

<style lang="scss" scoped>
  .el-button-group {
    width: 100%;

    .el-button {
      width: 50%;
    }
  }
</style>
